/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Inline_Default_HeadingInputs */

const en_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to continue`)
};

const es_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para continuar`)
};

const de_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an, um fortzufahren`)
};

const zh_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录以继续`)
};

const ar_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول للمتابعة`)
};

const fr_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour continuer`)
};

const vi_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để tiếp tục`)
};

const sw_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili kuendelea`)
};

const th_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้เพื่อดำเนินการต่อ`)
};

const bs_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se da nastavite`)
};

const ja_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続けるにはサインインしてください`)
};

const ko_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속하려면 로그인하세요`)
};

const pt_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para continuar`)
};

const it_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per continuare`)
};

const sv_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in för att fortsätta`)
};

const nl_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in om verder te gaan`)
};

const da_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind for at fortsætte`)
};

const nb_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn for å fortsette`)
};

const fi_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään jatkaaksesi`)
};

const pl_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby kontynuować`)
};

const ru_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы продолжить`)
};

const tr_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam etmek için giriş yapın`)
};

const hi_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जारी रखने के लिए साइन इन करें`)
};

const id_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk melanjutkan`)
};

const ms_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk meneruskan`)
};

const cs_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro pokračování se přihlaste`)
};

const el_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνδεθείτε για να συνεχίσετε`)
};

const he_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי להמשיך`)
};

const af_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld aan om voort te gaan`)
};

const hu_auth_inline_default_heading = /** @type {(inputs: Auth_Inline_Default_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A folytatáshoz jelentkezzen be`)
};

/**
* | output |
* | --- |
* | "Sign in to continue" |
*
* @param {Auth_Inline_Default_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_inline_default_heading = /** @type {((inputs?: Auth_Inline_Default_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Inline_Default_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_inline_default_heading(inputs)
	if (locale === "de") return de_auth_inline_default_heading(inputs)
	if (locale === "zh") return zh_auth_inline_default_heading(inputs)
	if (locale === "ar") return ar_auth_inline_default_heading(inputs)
	if (locale === "fr") return fr_auth_inline_default_heading(inputs)
	if (locale === "vi") return vi_auth_inline_default_heading(inputs)
	if (locale === "sw") return sw_auth_inline_default_heading(inputs)
	if (locale === "th") return th_auth_inline_default_heading(inputs)
	if (locale === "bs") return bs_auth_inline_default_heading(inputs)
	if (locale === "ja") return ja_auth_inline_default_heading(inputs)
	if (locale === "ko") return ko_auth_inline_default_heading(inputs)
	if (locale === "pt") return pt_auth_inline_default_heading(inputs)
	if (locale === "it") return it_auth_inline_default_heading(inputs)
	if (locale === "sv") return sv_auth_inline_default_heading(inputs)
	if (locale === "nl") return nl_auth_inline_default_heading(inputs)
	if (locale === "da") return da_auth_inline_default_heading(inputs)
	if (locale === "nb") return nb_auth_inline_default_heading(inputs)
	if (locale === "fi") return fi_auth_inline_default_heading(inputs)
	if (locale === "pl") return pl_auth_inline_default_heading(inputs)
	if (locale === "ru") return ru_auth_inline_default_heading(inputs)
	if (locale === "tr") return tr_auth_inline_default_heading(inputs)
	if (locale === "hi") return hi_auth_inline_default_heading(inputs)
	if (locale === "id") return id_auth_inline_default_heading(inputs)
	if (locale === "ms") return ms_auth_inline_default_heading(inputs)
	if (locale === "cs") return cs_auth_inline_default_heading(inputs)
	if (locale === "el") return el_auth_inline_default_heading(inputs)
	if (locale === "he") return he_auth_inline_default_heading(inputs)
	if (locale === "af") return af_auth_inline_default_heading(inputs)
	if (locale === "hu") return hu_auth_inline_default_heading(inputs)
	return en_auth_inline_default_heading(inputs)
});